<template>
  <div class="documents--preview">
    <div class="tile" target="_blank" @click="openPreview">
      <img v-if="document.thumbnailImage" :src="document.thumbnailImage" />
      <i v-if="!document.thumbnailImage" class="fa fa-file fa-lg"/>
    </div>
    <b-modal class="preview-modal" ref="preview-modal" hide-footer body-class="preview-modal--body">
      <img :src="document.filename" />
    </b-modal>
  </div>
</template>

<script>

// TODO: add full path to document.thumbnailImage when the api thumbnails will start to work
export default {
  props: ['document'],
  methods: {
    openPreview: function(e) {
      if ( !!this.document.thumbnailImage ) {
        e.preventDefault();
        this.$refs['preview-modal'].show()
      }
    }
  }
}
</script>

<style lang="scss">
.documents--preview {
  .tile {
    width: 70px;
    height: 70px;
    text-align: center;
    line-height: 70px;
    font-size: 22px;
    color: #ffffff;
    background: #e6e8e8;
    overflow: hidden;
    display: block;
  }
  .preview-modal img {
    max-width: 100%;
  }
  .preview-modal--body {
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
